<div [ngClass]="{ overlay: isSidebarActive }" class="shell layout-wrapper">
  @if (isMobileView) {
    <aside class="mobile-side-nav">
      <app-side-navigation (toggleSideBar)="sidebarToggle($event)" [isSidebarActive]="isSidebarActive"></app-side-navigation>
    </aside>
  } @else {
    <aside class="web-side-nav">
      <app-sidebar></app-sidebar>
    </aside>
  }
  <main>
    @if (isMobileView) {
      <header class="mobile-header">
        <app-topbar (openSideBar)="sidebarToggle($event)"></app-topbar>
      </header>
    } @else {
      <header class="web-header">
        <app-header></app-header>
      </header>
    }
    <div class="content">
      <router-outlet></router-outlet>
    </div>
    @if (isMobileView) {
      <footer class="mobile-footer">
        <app-bottom-navigation></app-bottom-navigation>
      </footer>
    }
  </main>
</div>
